<template>
  <div class="sidebar">
    <div class="sidebar-listing">
            <span class="close-side-bar" @click="$emit('closeSidemenu')">
                <i class="icon-delete"></i>
            </span>
      <div v-if="!activeDataSegmentList.length">
        <div class="skeleton-wrapper-inner">
          <div class="skeleton-wrapper-body">
            <div class="skeleton-avatar"></div>
          </div>
        </div>
      </div>
      <div v-else id="style-3" class="country-selection scrollable">
        <ul>
          <li
            v-for="(list, index) in activeDataSegmentList"
            :key="index"
            @click="$emit('onClick')"
          >
            <a
              href="javascript:void(0)"
              :class="
                                list._id == dataSegmentId
                                    ? 'router-link-exact-active router-link-active'
                                    : ''
                            "
              @click.prevent="setDataSegmetId(index, list._id)"
            >
              <span>{{ list.code }}</span>
            </a>
          </li>
        </ul>
      </div>
      <div class="sidebar-nav">
        <div class="logo-container">
          <base-logo></base-logo>
        </div>
        <div class="navigation">
          <ul>
            <li
              v-for="(list, index) in allowedSidelinksListing"
              :key="index"
              @click="$emit('onClick')"
            >
              <router-link :to="list.anchorLink">
                <i :class="list.icon"></i>
                <span>{{ list.menuLabel }}</span>
              </router-link>
            </li>
          </ul>
        </div>
        <login-popover></login-popover>
      </div>
    </div>
    <login-detail></login-detail>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import loginDetail from "@/components/LoginDetail.vue";
import loginPopover from "@/components/LoginPopover.vue";
import resource from "@/api/resource";
import _ from "lodash";

const dataSegmentApi = new resource("access-control/data-segments");
const viewBrandingApi = new resource("configurations/branding");
export default {
  /*
  |--------------------------------------------------------------------------
  | Component > components
  |--------------------------------------------------------------------------
  */
  components: { loginDetail, loginPopover },
  /*
  |--------------------------------------------------------------------------
  | Component > props
  |--------------------------------------------------------------------------
  */
  props: {}, // End of Component > props
  /*
  |--------------------------------------------------------------------------
  | Component > data
  |--------------------------------------------------------------------------
  */
  data() {
    return {
      dataSegmentListing: [],
      userDataSegmentIds: [],
      // Data Segment listing variables
      query: {
        startAt: 1,
        keyword: "",
        perPage: 1000,
        roleId: null,
        dataSegmentId: null,
        status: "active"
      },
      image: "profile-pic.png",
      sidelinksListing: [
        {
          anchorLink: "/insights",
          icon: "icon-insights",
          menuLabel: "Insights",
          permission: [
            "view-alerts",
            "view-activity-dashboard",
            "view-customer-statistics"
          ]
        },
        {
          anchorLink: "/customer-profiles",
          icon: "icon-customer-profil",
          menuLabel: "Customers",
          permission: ["view-customer-profile"]
        },
        // {
        //     anchorLink: '/register-customer',
        //     icon: 'icon-add-customer',
        //     menuLabel: 'Register Customer',
        //     permission: ['register-customer'],
        // },
        // {
        //   anchorLink: "/ssa-customer",
        //   icon: "icon-add-customer",
        //   menuLabel: "Sahulat Sarmayakari Account",
        //   permission: ["ssa-customer"]
        // },
        {
          anchorLink: "/configuration",
          icon: "icon-configurations",
          menuLabel: "Configurations",
          permission: [
            "idenfo-engine",
            "view-screening-data",
            "form-builder",
            "initiate-simulation-process",
            "branding",
            "ocr"
          ]
        },
        {
          anchorLink: "/system-users",
          icon: "icon-system-users",
          menuLabel: "System Users",
          permission: [
            "view-system-users",
            "manage-system-users",
            "view-roles",
            "manage-roles",
            "view-data-segments",
            "manage-data-segments",
            "view-application-access",
            "manage-application-access"
          ]
        },
        {
          anchorLink: "/system-logs",
          icon: "icon-system-log",
          menuLabel: "System Logs",
          permission: ["system-logs"]
        }
      ],
      dataSegmentId: null,
      activeDataSegId: 1,
      options: []
    };
  }, // End of Component > data
  /*
  |--------------------------------------------------------------------------
  | Component > computed
  |--------------------------------------------------------------------------
  */
  computed: {
    ...mapGetters(["user", "scopes", "refreshDataSegmentList"]),
    allowedSidelinksListing() {
      return this.sidelinksListing.filter((item) => {
        return this.checkPermission(item.permission);
      });
    },
    activeDataSegmentList() {
      return this.dataSegmentListing.filter((item) => {
        return (item.status = "active");
      });
    }
  }, // End of Component > computed


  async mounted() {
    await this.getDataSegments();

    this.changeRoutes()
  },

  /*
  |--------------------------------------------------------------------------
  | Component > watch
  |--------------------------------------------------------------------------
  */
  watch: {
    dataSegmentId(value) {
      if (value) {
        this.$store.commit("setDataSegmentId", value);
      }
    },
    user(value) {
      if (!value && this.$route.meta.requiresAuth) {
        this.$router.push({ name: "login-page" });
      }
    }, // End of user() method
    refreshDataSegmentList(value) {
      if (value) {
        this.getRecords();
        this.$store.commit("setRefreshDataSegmentList", false);
      }
    } // End of refreshDataSegmentList() method
  }, // End of Component > watch
  async created() {
    // Load All Data Segments
    if (!localStorage.getItem("displaySettings")) {
      await this.getBrandingData();
    }
    await this.getRecords();
  }, // End of Component > created
  /*
  |--------------------------------------------------------------------------
  | Component > methods
  |--------------------------------------------------------------------------
  */
  methods: {
    async getRecords() {
      let self = this;
      // Data segments option list
      let { data } = await dataSegmentApi.list(self.query);
      let dataSegmentId = null;
      let localStorageTem = localStorage.getItem("dataSegmentId");
      if (self.user && data.data) {
        if (
          self.user.dataSegmentIds &&
          self.user.dataSegmentIds.length
        ) {
          self.userDataSegmentIds = self.user.dataSegmentIds;
          data.data.forEach(function(ele) {
            if (
              self.userDataSegmentIds.includes(ele._id) &&
              ele.status == "active"
            ) {
              self.dataSegmentListing.push(ele);
            }
          });
          dataSegmentId = self.dataSegmentListing[0]._id;
        } else {
          self.dataSegmentListing = data.data;
          if (self.dataSegmentListing.length) {
            dataSegmentId = self.dataSegmentListing[0]._id;
          }
        }
        if (localStorageTem) {
          let check = this.dataSegmentListing.find(
            (x) => x._id === localStorageTem
          );
          if (check) {
            this.dataSegmentId = localStorageTem;
          } else {
            this.dataSegmentId = dataSegmentId;
          }
        } else {
          localStorage.setItem("dataSegmentId", dataSegmentId);
          this.dataSegmentId = dataSegmentId;
        }
      }
      // Get all data segments in dataSegmentListing
    }, // End of getOptionsList() method

    setDataSegmetId(val, id) {
      this.activeDataSegId = val;
      this.dataSegmentId = id;
      localStorage.setItem("dataSegmentId", id);
      this.changeRoutes();
    },

    async getDataSegments() {
      let self = this;
      //data segments list

      let dataSegmentList = await dataSegmentApi.list({
        status: "active",
        perPage: 1000
      });
      self.options = [];
      self.options.push({ code: "ALL", id: "all" });
      dataSegmentList.data.data.forEach(function(val) {
        self.options.push({ code: val.code, id: val._id });
      });
    },
    checkPermission(scopes) {
      return !!_.intersection(scopes, this.scopes).length;
    },
    async getBrandingData() {
      let { data } = await viewBrandingApi.list();
      this.$store.commit("setDisplaySetting", data.data);
    }, // End of getBrandingData() method

    //  Changing Routes, Activated Routes according to DataSegment Change
    changeRoutes() {
      let arrayregister = [
        {
          anchorLink: "/insights",
          icon: "icon-insights",
          menuLabel: "Insights",
          permission: [
            "view-alerts",
            "view-activity-dashboard",
            "view-customer-statistics"
          ]
        },
        {
          anchorLink: "/customer-profiles",
          icon: "icon-customer-profil",
          menuLabel: "Customers",
          permission: ["view-customer-profile"]
        },
        {
          anchorLink: "/register-customer",
          icon: "icon-add-customer",
          menuLabel: "Register Customer",
          permission: ["register-customer"]
        },
        // {
        //   anchorLink: "/ssa-customer",
        //   icon: "icon-add-customer",
        //   menuLabel: "Sahulat Sarmayakari Account",
        //   permission: ["ssa-customer"]
        // },
        {
          anchorLink: "/configuration",
          icon: "icon-configurations",
          menuLabel: "Configurations",
          permission: [
            "idenfo-engine",
            "view-screening-data",
            "form-builder",
            "initiate-simulation-process",
            "branding",
            "ocr"
          ]
        },
        {
          anchorLink: "/system-users",
          icon: "icon-system-users",
          menuLabel: "System Users",
          permission: [
            "view-system-users",
            "manage-system-users",
            "view-roles",
            "manage-roles",
            "view-data-segments",
            "manage-data-segments",
            "view-application-access",
            "manage-application-access"
          ]
        },
        {
          anchorLink: "/system-logs",
          icon: "icon-system-log",
          menuLabel: "System Logs",
          permission: ["system-logs"]
        }
      ];
      let arrayssk = [
        {
          anchorLink: "/insights",
          icon: "icon-insights",
          menuLabel: "Insights",
          permission: [
            "view-alerts",
            "view-activity-dashboard",
            "view-customer-statistics"
          ]
        },
        {
          anchorLink: "/customer-profiles",
          icon: "icon-customer-profil",
          menuLabel: "Customers",
          permission: ["view-customer-profile"]
        },
        // {
        //     anchorLink: '/register-customer',
        //     icon: 'icon-add-customer',
        //     menuLabel: 'Register Customer',
        //     permission: ['register-customer'],
        // },
        {
          anchorLink: "/ssa-customer",
          icon: "icon-add-customer",
          menuLabel: "Sahulat Sarmayakari Account",
          permission: ["ssa-customer"]
        },
        {
          anchorLink: "/configuration",
          icon: "icon-configurations",
          menuLabel: "Configurations",
          permission: [
            "idenfo-engine",
            "view-screening-data",
            "form-builder",
            "initiate-simulation-process",
            "branding",
            "ocr"
          ]
        },
        {
          anchorLink: "/system-users",
          icon: "icon-system-users",
          menuLabel: "System Users",
          permission: [
            "view-system-users",
            "manage-system-users",
            "view-roles",
            "manage-roles",
            "view-data-segments",
            "manage-data-segments",
            "view-application-access",
            "manage-application-access"
          ]
        },
        {
          anchorLink: "/system-logs",
          icon: "icon-system-log",
          menuLabel: "System Logs",
          permission: ["system-logs"]
        }
      ];

      var dataSegments = JSON.parse(JSON.stringify(this.options));

      let dataSegmentCurrent = dataSegments.filter((item) => {
        if (item.id == this.dataSegmentId) {
          // console.log("Matched");
          return item;
        }
      });
      // console.log("this.$route.path", this.$route.path);
      if (dataSegmentCurrent[0].code == "RC") {
        // console.log("on rc")
        this.sidelinksListing = arrayregister;
        if (this.$route.path.includes("/ssa-customer")) {
          //
          // this.$router.push("/ssa-customer");
          // this.$router.push("/register-customer");

          this.$router.push('/register-customer').catch(failure => {
            // if (isNavigationFailure(failure, NavigationFailureType.redirected)) {
            //   // show a small notification to the user
            //   showToast('Login in order to access the admin panel')
            // }
            this.$router.push("/register-customer");
          })

        }
      } else if (dataSegmentCurrent[0].code == "SSK") {
        //  console.log("on ssk")
        this.sidelinksListing = arrayssk;
        if (this.$route.path.includes("/register-customer")) {
          // this.$router.push("/ssa-customer/");
          this.$router.push('/ssa-customer').catch(failure => {
            // if (isNavigationFailure(failure, NavigationFailureType.redirected)) {
            //   // show a small notification to the user
            //   showToast('Login in order to access the admin panel')
            // }
            this.$router.push("/ssa-customer");
          })
          // this.$router.push({ path: "/ssa-customer/" });
        }
      }

    } // End of changeRoutes()

  } // End of Component > methods
}; // End of export default
</script>
